'use client';

import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * SSR-safe mobile detection. Returns `false` on the first (server/hydration)
 * render to avoid hydration mismatches, then updates on mount and on resize.
 *
 * "Mobile" = narrow viewport (< 768px) OR a touch-primary device, matching the
 * behavior previously duplicated across several components.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT || 'ontouchstart' in window);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}
